import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const eOneInstance = axios.create({
  baseURL: '/',
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const request = async <T = any>(config: AxiosRequestConfig): Promise<T> => {
  const response = await eOneInstance.request<T>(config);
  return response as T;
};

const get = <T = any>(url: string, params?: any, config?: AxiosRequestConfig) =>
  request<T>({ ...config, method: 'get', url, params });

const post = <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
  request<T>({ ...config, method: 'post', url, data });

const put = <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
  request<T>({ ...config, method: 'put', url, data });

const del = <T = any>(url: string, config?: AxiosRequestConfig) =>
  request<T>({ ...config, method: 'delete', url });

const EOneRequest = {
  request,
  get,
  post,
  put,
  del,
};

export { EOneRequest, eOneInstance };
